import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './eFormsProperties.html?raw';

import DateTimeInput from '../../moreCore/UI/DateTimeInput/DateTimeInput';
import "../../moreCore/UI/DateTimeInput/DateTimeInput";
import DateInput from '../../moreCore/UI/DateInput/DateInput';
import "../../moreCore/UI/DateTimeInput/DateTimeInput";
import MultiSelectBox from '../../moreCore/UI/EntityBased/MultiselectBox/MultiselectBox';
import "../../moreCore/UI/EntityBased/MultiselectBox/MultiselectBox";
import HintBox from '../../moreCore/UI/HintBox/HintBox';
import MultiselectBox from '../../moreCore/UI/EntityBased/MultiselectBox/MultiselectBox';
import domClass from 'dojo/dom-class';
import domAttr from 'dojo/dom-attr';
import domConstruct from 'dojo/dom-construct';
import SearchSelect from '../../moreCore/UI/SearchSelect/SearchSelect';
import ExpandableSection from '../../moreCore/UI/Container/ExpandableSection';
import { ExpandableSectionMarkings, HTMLElementWithExpander } from "../../moreCore/UI/Container/ExpandableSectionTypes";
import _StatefulBase from '../../moreCore/UI/_StatefulBase/_StatefulBase';
import Button from '../../moreCore/UI/Button/Button';
import { DateHelpers, StringHelpers, TranslationHelpers } from "../../more/Helpers";
import Edit from '../../moreCore/UI/Edit/Edit';
import NumberInput from '../../moreCore/UI/NumberInput/NumberInput';
import CheckBox from '../../moreCore/UI/CheckBox/CheckBox';
import RadioGroup from '../../moreCore/UI/RadioGroup/RadioGroup';


interface propertyExpander {
    expander: MdsLax<InstanceType<typeof ExpandableSection>>
    expanded: boolean,
    groupGUID: string
}

const enum eFormsPropertyTypes {
    "text" = 0,
    "textMultiline" = 10,
    "number" = 1,
    "select" = 2,
    "filterselect" = 21,
    "multiselect" = 3,
    "filtermultiselect" = 31,
    "file" = 4,
    "multifile" = 41,
    "date" = 5,
    "datetime" = 6,
    "hintbox" = 7,
    "eform" = 8,
    "yesno" = 9,
    "separator" = 10,
    "heading" = -1,
    "headingSmall1" = -2,
    "headingSmall2" = -3,
    "replicatingGroup" = 999
}
class eFormsProperties extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private tableContainer: HTMLElement;
    private theadContainer: HTMLElement;
    private tbodyContainer: HTMLElement;
    private navigationContainer: HTMLElement;
    hintboxInput: MdsLax<InstanceType<typeof HintBox>>;

    _jsonDataIn: Array<eFormsTypes.PropertyAssignment> = null;
    _jsonDataOut: Array<eFormsTypes.PropertiesTableRowOutput> = null;
    _jsonDataString: string = "";

    isReadonly: boolean = false;
    isValid: boolean = false;
    //private groupNumber: number = null;
    //private groupGUID: string = null;
    private groupEntryData: eFormsTypes.PropertiesTableGroupEntry = null;

    //primaryKeyAttribute: string = "ID";
    //valueAttribute: string= "value_text_global";
    //typeAttribute: string = "ref_eform_property.property_type";
    //mandatoryAttribute: string = "is_mandatory";
    //labelAttribute: string = "ref_eform_property.description";
    private rows: Array<eFormsTypes.PropertiesTableRow> = null;



    private drawRow(entity: eFormsTypes.PropertyAssignment): void {
        //##
        //console.debug("drawRow", entity);
        //##
        let entityID: string = entity.ID;
        let row: eFormsTypes.PropertiesTableRow = this.getRowByKey(entityID);



        if (row != null) {
            this.UiModder.domConstruct.destroy(row.rowNode);
            row.rowNode = null;
            row.valueNode = null;

        } else {
            row = {
                propertyDescriptor: entity,
                valid: true,
                value: null,
                input: null,
                labelNode: null,
                rowNode: null,
                valueNode: null,
                propertyContainerNode: null,
                descriptionNode: null,
                groupContent: null,
                notApplicableCBnode: null,
                notApplicableCB: null,
                notApplicable: false
            };
            this.rows.push(row);
        }


        row.propertyDescriptor = entity;

        let property = row.propertyDescriptor.ref_eform_property;

        let tr: HTMLTableRowElement = <HTMLTableRowElement>this.UiModder.domConstruct.create("tr",
            {
                "className": "propRow",
            },
            this.tbodyContainer);
        row.rowNode = tr;


        let labelElementType: string = "label";
        switch (property.property_type) {
            case eFormsPropertyTypes.heading:
                labelElementType = "h4";
                break;

            case eFormsPropertyTypes.headingSmall1:
                labelElementType = "h4";
                break;

            case eFormsPropertyTypes.headingSmall2:
                labelElementType = "h5";
                break;
        }

        let label = this.UiModder.domConstruct.create(labelElementType,
            {
                "innerHTML": property.description,
                "className": "propertyLabel",
                style: {
                }
            }, tr);

        row.labelNode = label;



        // wenn ich zu einer Gruppe gehöre:
        //console.debug("group Title formatting?", this.groupEntryNo, row.propertyDescriptor);
        let propertyContainerType = "div";

        if (row.propertyDescriptor.group_property_title) {
            label.innerHTML = row.propertyDescriptor.group_property_title;
            propertyContainerType = "td";
        }

        let propertyContainer = <HTMLElement>this.UiModder.domConstruct.create(propertyContainerType,
            {
                "className": "propertyContainer"// flex_row_center"
            }, tr);

        row.propertyContainerNode = propertyContainer;

        row.valueNode = this.UiModder.domConstruct.create("div",
            {
                "className": "propertyValue"// flex_row_center"
            }, row.propertyContainerNode);

        row.notApplicableCBnode = this.UiModder.domConstruct.create("div",
            {
                "className": "propertyNotApplicableContainer w3-hide"// flex_row_center"
            }, row.propertyContainerNode);

        if (property.description_long) {

            let helptextContainer = this.UiModder.domConstruct.create("div",
                {
                    "colspan": "2",
                    "className": "helptext",
                    "innerHTML": ""
                }, row.propertyContainerNode);

            row.helptextRownode = helptextContainer;


            this.UiModder.domConstruct.create("span", { "innerHTML": property.description_long }, helptextContainer);

        } else {
            this.UiModder.domClass.add(tr, "rowBottom");
        }

        this.UiModder.domConstruct.place(label, row.propertyContainerNode, "first");

        switch (property.property_type) {
            case eFormsPropertyTypes.number: // Zahl > wegen Tausendertrennzeichen und so das tatsächliche Wertattribut auslesen
                row.value = this.PitHelper.getEntityAttributeValue(entity, "value_double", "json");
                break;
            case eFormsPropertyTypes.select: // Entity-ID des gewählten Wertes
            case eFormsPropertyTypes.multiselect: // Entity-IDs sind hier mit Pipes getrennt am text-Value
                row.value = entity.value_text;
                break;
            case eFormsPropertyTypes.hintbox: // enthält etwas erweiterte Infos, kein schnödes Text-Dingsl
            case eFormsPropertyTypes.eform: // verhält sich wie hintbox
            case eFormsPropertyTypes.filtermultiselect: // enthält etwas erweiterte Infos, kein schnödes Text-Dingsl
            case eFormsPropertyTypes.filterselect: // enthält etwas erweiterte Infos, kein schnödes Text-Dingsl
                row.value = entity.value_json;
                break;

            case eFormsPropertyTypes.text:
            case eFormsPropertyTypes.textMultiline:
                row.value = entity.value_text;
                break;

            case eFormsPropertyTypes.yesno:
                row.value = entity.value_yesno;
                break;

            case eFormsPropertyTypes.replicatingGroup:
                row.value = entity.value_display;
                this.UiModder.domConstruct.place(row.valueNode, row.propertyContainerNode, "last"); // bei Gruppen den Inhalt NACH den ggf. existierenden helptext stellen
                break;

            default:
                row.value = entity.value_display;
                break;
        }


        if (this.rows.length % 2 == 0) {
            this.UiModder.domClass.add(tr, "pong");
        } else {
            this.UiModder.domClass.add(tr, "ping");
        }



        this.constructInput(row);
    }

    setGroupCountTitles(data: eFormsTypes.GroupPropertyTitles) {
        //;
        console.debug("setGroupCountTitles", data, this.rows);
        if (data && data.formattedTitles) {
            for (let row of this.rows) {
                for (let titleData of data.formattedTitles) {
                    if (titleData.assignmentID == row.propertyDescriptor.ID ||
                        (row.propertyDescriptor.ref_ht_eform_property_group_source &&
                            row.propertyDescriptor.ref_ht_eform_property_group_source.ID == titleData.assignmentID)) {
                        row.labelNode.innerHTML = titleData.title;

                        break;
                    }
                }
            }
        }

        this.UiModder.domClass.remove(this.domNode, "obsoleteLabels");

        if (this.groupEntryCountNode) {
            this.groupEntryCountNode.innerHTML = this.groupEntryData.groupOrder.toString();
        }
    }

    checkMandatory(targetRow?: eFormsTypes.PropertiesTableRow, scrollIntoView?: boolean): boolean {
        let isValid: boolean = true;

        //console.debug("checkMandatory", this.rows, targetRow);

        if (this.isReadonly === true) {
            this.isValid = true;
            return this.isValid;
        }


        let targetRows: Array<eFormsTypes.PropertiesTableRow> = [];
        if (typeof (targetRow) != "undefined" && targetRow != null) {
            targetRows.push(targetRow);
        } else {
            targetRows = this.rows;
        }

        for (let i = 0; i < targetRows.length; i++) {
            let row: eFormsTypes.PropertiesTableRow = targetRows[i];
            let isMandatory: boolean = false;
            let check: boolean = true;

            if (true) {
                let property = row.propertyDescriptor.ref_eform_property;

                let allowNonApplicable = row.propertyDescriptor.is_allow_select_not_applicable === true;

                isMandatory = row.propertyDescriptor.is_mandatory == true;

                isMandatory = isMandatory && row.notApplicable != true;


                switch (property.property_type) {
                    case eFormsPropertyTypes.heading:
                    case eFormsPropertyTypes.headingSmall1:
                    case eFormsPropertyTypes.headingSmall2:
                        if (isMandatory) {
                            this.UiModder.domClass.add(row.rowNode, "mandatoryHeading");
                        }
                        check = true;
                        break;

                    case eFormsPropertyTypes.number: // Zahl
                    case eFormsPropertyTypes.textMultiline: // Text
                    case eFormsPropertyTypes.text: // Text
                    case eFormsPropertyTypes.multiselect: // mehrfachauswahl
                    case eFormsPropertyTypes.filtermultiselect: // mehrfach
                    case eFormsPropertyTypes.hintbox: //hintbox
                    case eFormsPropertyTypes.eform: //hintbox
                    case eFormsPropertyTypes.filterselect: //hintbox
                    case eFormsPropertyTypes.select: // einfaches Select
                    case eFormsPropertyTypes.date: // datum
                    case eFormsPropertyTypes.datetime: // datum + zeit
                    case eFormsPropertyTypes.yesno: // datum + zeit
                        let control: MdsLax<InstanceType<typeof _StatefulBase>> = row.input;
                        control.setMandatory(isMandatory);
                        check = control.isValid;
                        break;

                    case eFormsPropertyTypes.file:
                    case eFormsPropertyTypes.multifile:
                        //console.debug("checkMandatory file", row.value);
                        check = false;
                        for (let x = 0; x < row.value.length; x++) {
                            let file = row.value[x];
                            if (file.isRemove !== true) {
                                check = true;
                                break;
                            }
                        }
                        break;

                    //case eFormsPropertyTypes.yesno:
                    //    // geht nur, wenn wirklich noch null als wert steht und das nicht zulässig wäre
                    //    check = true;
                    //    //let cb: CheckBox = row.input;
                    //    //check = cb.isValid;
                    //    //if (isMandatory && cb.getValue() === null) {
                    //    //    check = false;
                    //    //}
                    //    let rg: RadioGroup = row.input;
                    //    check = rg.isValid;
                    //    if (isMandatory && rg.getValue() === null) {
                    //        check = false;
                    //    }
                    //    break;


                    case eFormsPropertyTypes.replicatingGroup:
                        let minEntries = row.propertyDescriptor.group_entries_min;
                        let maxEntries = row.propertyDescriptor.group_entries_max;

                        if (!minEntries && row.propertyDescriptor.is_mandatory == true) {
                            minEntries = 1;
                        }

                        check = !minEntries && !maxEntries;


                        if (!check && row.groupContent) {
                            check = true;
                            let count = 0;
                            for (let entry of row.groupContent.groupEntries) {
                                if (!entry.deleted) {
                                    count++;
                                }
                            }
                            if (minEntries) {

                                if (count < minEntries) {
                                    check = false;

                                }
                            }

                            if (maxEntries) {
                                if (count > maxEntries) {
                                    check = false;

                                }
                                if (count >= maxEntries) {
                                    domClass.add(row.groupContent.addButton, "w3-disabled");
                                }

                                else {
                                    domClass.remove(row.groupContent.addButton, "w3-disabled");
                                }
                            }
                        }

                        if (check) {
                            for (let entry of row.groupContent.groupEntries) {
                                if (!entry.deleted) {
                                    let table: eFormsProperties = entry.table;
                                    table.checkMandatory();
                                    if (!table.isValid) {
                                        check = false;
                                        if (entry.expander) {
                                            (entry.expander as MdsLax<InstanceType<typeof ExpandableSection>>).setMarking(ExpandableSectionMarkings.warning);
                                        }
                                    } else {
                                        if (entry.expander) {
                                            (entry.expander as MdsLax<InstanceType<typeof ExpandableSection>>).setMarking(ExpandableSectionMarkings.default);
                                        }
                                    }
                                }
                            }
                        }

                        break;

                }

                if ((isMandatory === true && check != true )) {
                    isValid = false;
                    row.valid = false;
                    this.UiModder.domClass.add(row.rowNode, "mandatoryMissing");

                    if (scrollIntoView === true) {
                        row.rowNode.scrollIntoView({ behavior: "smooth", block: "nearest" });
                        scrollIntoView = false;
                    }

                } else {
                    this.UiModder.domClass.remove(row.rowNode, "mandatoryMissing");
                    row.valid = true;
                }


            }
        }

        if (typeof (targetRow) != "undefined" && targetRow != null) {
            if (isValid !== true) {
                this.isValid = false;
                return this.isValid;
            }

            // ansonsten alle rows durchgehen:
            for (let row of this.rows) {
                if (!row.valid) {
                    isValid = false;
                    break;
                }
            }
        }

        this.isValid = isValid;
        return this.isValid;
    }

    private _onClick_NavigateUp(evt: MouseEvent) {
        this.domNode.scrollIntoView({ behavior: "smooth" });
    }

    private constructInput(row: eFormsTypes.PropertiesTableRow) {


        let input:any = null;
        let container: HTMLElement = null;
        let entity: eFormsTypes.PropertyAssignment = row.propertyDescriptor;

        let isMandatory: boolean = entity.is_mandatory === true;

        let property = row.propertyDescriptor.ref_eform_property;


        // nicht zutreffend? bei Überschriften usw nicht anbieten!
        switch (property.property_type) {
            case eFormsPropertyTypes.heading:
            case eFormsPropertyTypes.headingSmall1:
            case eFormsPropertyTypes.headingSmall2:
            case eFormsPropertyTypes.replicatingGroup:

                break;

            default:
                if (entity.is_allow_select_not_applicable == true || entity.is_not_applicable == true) {
                    let NAcheckbox = new CheckBox();
                    NAcheckbox.placeAt(row.notApplicableCBnode, "last");

                    NAcheckbox.setLabel("eForms__NotApplicable");
                    NAcheckbox.setValue(entity.is_not_applicable);

                    NAcheckbox.setReadonly(this.isReadonly || (entity.is_allow_select_not_applicable != true && entity.is_not_applicable != true));

                    NAcheckbox.on("change", lang.hitch(this, this._onInputChanged, row));

                    row.notApplicableCB = NAcheckbox;

                    this.hideNode(row.notApplicableCBnode, false);
                }
                break;
        }



        switch (property.property_type) {
            case eFormsPropertyTypes.heading:
            case eFormsPropertyTypes.headingSmall1:
            case eFormsPropertyTypes.headingSmall2:
                input = null;
                if (row.valueNode) {
                    domConstruct.destroy(row.valueNode);
                }
                if (row.labelNode) {
                    //let target = this.navigationContainer;
                    //let btnUp = this.UiModder.domConstruct.create("button", {
                    //    className: "mds-button-base roundest mediumBG hoverBright w3-margin-right w3-small",
                    //    innerHTML: this.createFontawesomeIcon("fas fa-arrow-up").outerHTML
                    //}, row.labelNode, "first");
                    //on(btnUp, "click", function () { target.scrollIntoView(); });

                    domClass.add(row.rowNode, "heading");
                    domAttr.set(row.labelNode, "colSpan", 2);

                    if (property.property_type == eFormsPropertyTypes.headingSmall1) {
                        domClass.add(row.rowNode, "small1");
                    } else if (property.property_type == eFormsPropertyTypes.headingSmall2) {
                        domClass.add(row.rowNode, "small2");
                    }
                }

                this.hideNode(this.navigationContainer, false);
                let btn = new Button();
                btn.setup({
                    label: entity.ref_eform_property.description,
                    styleClass: "flex_cell_33p tertiaryBtn",
                    iconLeft: "fas fa-arrow-down",
                    parentNode: this.navigationContainer,
                    callback: function () { row.rowNode.scrollIntoView({ behavior: "smooth" }) }
                });

                break;
            case eFormsPropertyTypes.text: // text
            case eFormsPropertyTypes.textMultiline: // text
                let edit = new Edit();
                edit.setIsMultiline(property.property_type == eFormsPropertyTypes.textMultiline);
                edit.placeAt(row.valueNode);
                edit.setValue(row.value);

                input = edit;

                edit.setReadonly(this.isReadonly);

                break;

            case eFormsPropertyTypes.yesno:
                //let cb = new CheckBox();
                //cb.setType("tristateQuestion");
                //cb.setLabel(property.description);
                //cb.setConditionalLabels("General_Label_Yes", "General_Label_No", "General_Label_Undefined");
                //cb.setIsTristate(true);// !isMandatory);
                //cb.placeAt(row.valueNode);
                //cb.setValue(row.value);


                ////this.hideNode(row.labelNode);
                //input = cb;

                //cb.setReadonly(this.isReadonly);

                let rg = new RadioGroup({
                    alignment: "horizontal",
                    paddings:"bigger",
                    entries: [{
                        label: "General_Label_Yes",
                        value: true
                    }, {
                            label: "General_Label_No",
                            value: false
                        }]
                });

                rg.placeAt(row.valueNode);
                rg.setValue(row.value);

                rg.setMandatory(true);
                if (!isMandatory) {
                    rg.addEntry(null, "eForms__Label_YNProperty_notSelected");

                    if (row.value == undefined || row.value == null) rg.setValue(null, true);
                }



                input = rg;

                break;

            case eFormsPropertyTypes.number: // Zahl
                let nInput = new NumberInput();
                let nValue: number = null;
                if (typeof (row.value) == "number") nValue = row.value;
                else if (typeof (row.value) == "string") nValue = parseFloat(row.value);
                if (typeof (nValue) == "number" && !isNaN(nValue)) nInput.setValue(nValue);
                nInput.placeAt(row.valueNode);

                input = nInput;

                // Nachkomma: wir bekommen 0-x von evis, aber im HTML geben wir die Schrittweite an (zb 0.01 wenn x = 2)
                if (entity.ref_eform_property.precision >= 0 && typeof entity.ref_eform_property.precision == "number") {
                    let places = entity.ref_eform_property.precision;
                    nInput.setPlaces(places);
                }

                if (entity.ref_eform_property.unit_label) {
                    nInput.setUnit(entity.ref_eform_property.unit_label);
                }

                if (entity.ref_eform_property.value_min) {
                    nInput.setMinRange(entity.ref_eform_property.value_min)
                }
                if (entity.ref_eform_property.value_max) {
                    nInput.setMaxRange(entity.ref_eform_property.value_max)
                }

                break;

            case eFormsPropertyTypes.select: // Werteliste (Einfachauswahl)

                let select1 = new SearchSelect();
                select1.setCyName("eFormsPropertyTypes");

                //select.setLabel(property.hintbox_input_label);
                select1.labelAttribute = "description";
                select1.valueAttribute = "ID";
                select1.validationEnabled = true;
                select1.setSelectionListLEGACY(entity.ref_eform_property.EL_values)

                select1._setPlaceholderAttr(this.translate("General_Search"), this.translate("General_DropdownBlank_NoSelection"));
                if (entity.is_mandatory) {
                    select1._setPlaceholderAttr(this.translate("General_Search"), this.translate("General_DropdownBlank_Choose"));
                }

                input = select1;

                this.UiModder.domConstruct.place(input.domNode, row.valueNode);

                if (entity.value_text) {
                    select1.setValue(entity.value_text);
                }

                break;

            case eFormsPropertyTypes.multiselect: // Werteliste (Mehrfachauswahl)
                let msBox = new MultiSelectBox();
                msBox.setCyName("eFormsPropertyTypes");
                input = msBox;
                this.UiModder.domStyle.set(input.domNode, "width", "100%");
                input.labelAttribute = "description";
                input.value = "ID";

                msBox._setPlaceholderAttr(this.translate("General_Search"), this.translate("General_DropdownBlank_NoSelection"));
                if (entity.is_mandatory) {
                    msBox._setPlaceholderAttr(this.translate("General_Search"), this.translate("General_DropdownBlank_Choose"));
                }

                if (this.isReadonly === true) {
                    input.set("readonly", true);
                }

                this.UiModder.domConstruct.place(input.domNode, row.valueNode);
                let cellValue: any = row.value;
                cellValue = row.value;
                let selectedValues = [];
                if (cellValue != "" && cellValue != null && typeof (cellValue) != "undefined") {
                    selectedValues = cellValue.split("|");
                }

                let options = [];
                let optionIDs = [];
                let optionLabels = [];
                let selectionIds = [];
                for (let i = 0; i < entity.ref_eform_property.EL_values.length; i++) {
                    let propValue = entity.ref_eform_property.EL_values[i];
                    //options.push(propValue);
                    optionIDs.push(propValue.ID);
                    optionLabels.push(propValue[msBox.labelAttribute]);

                    if (selectedValues.indexOf(propValue.ID, 0) != -1) {
                        selectionIds.push(propValue.ID);
                    }
                }

                msBox.setOptions(optionIDs, optionLabels, selectionIds);

                row.value = input.get("value");

                break;




            case eFormsPropertyTypes.file: // file (single)
            case eFormsPropertyTypes.multifile: // file (multi)
                row.downloads = [];

                container = this.UiModder.domConstruct.create("div", {
                    "className": "flex_row_center",
                    style: {
                        "width": "100%"
                    }
                }, row.valueNode);

                row.downloadsNode = container;

                //if (this.isReadonly !== true) {
                input = this.UiModder.domConstruct.create("input",
                    {
                        "className": "w3-block w3-padding-y",
                        "type": "file",
                        //"disabled": this.isReadonly === true ? "disabled" : "false",
                    }, row.valueNode);

                if (property.property_type == 41) {
                    this.UiModder.domAttr.set(input, "multiple", "true");
                }
                //}
                row.input = input; // muss hier gesetzt werden bei files, weil readattachments drauf zugreift
                this.readAttachments(row);
                break;


            case eFormsPropertyTypes.datetime: // datum + zeit
                // moreCore widget: handels time and date input magically. Takes Date as setValue arg, gives a Date back.

                input = this._createDatetimeInput(row, this.PitHelper.getEntityAttributeValue(entity, "value_date", "json"));

                break;

            case eFormsPropertyTypes.date: // datum

                input = this._createDateInput(row, this.PitHelper.getEntityAttributeValue(entity, "value_date", "json"));

                break;

            case eFormsPropertyTypes.hintbox: //hintbox

                let hintbox = new HintBox();

                hintbox.setLabel(property.hintbox_input_label);
                hintbox.suggestionLabelAttribute = property.entity_label_attribute;
                hintbox.setLabelAttribute(property.entity_label_attribute);
                hintbox.minLetterCount = property.hintbox_min_letter_count;
                hintbox.resetOnEdit = true;
                //hintbox.enablePlainTextValue = false;
                hintbox.setEnablePlaintextValue(property.is_allow_plaintext_value == true);
                //hintbox.dataFormat = "json";//row.entity.ref_vt_property.hintbox_data_format;
                hintbox.setCallfunction("Webtool_eForms_API__LoadPropertyHintboxResults");
                hintbox.addAdditionalRequestParameter("propertyID", property.ID); // damit API die restliche Konfig wieder findet

                hintbox.validationEnabled = entity.is_mandatory == true;

                if (entity.value_text && property.is_allow_plaintext_value == true) {
                    hintbox.setValue(entity.value_text);
                }
                else if (entity.value_json) {
                    try {
                        let obj = JSON.parse(<string>entity.value_json);
                        hintbox.setValue(obj, true);
                    } catch (e) {
                        console.error(this.id + " error parsing hintbox json-value", entity, e);
                    }
                }

                input = hintbox;

                this.UiModder.domConstruct.place(input.domNode, row.valueNode);
                break;

            case eFormsPropertyTypes.eform:

                // wie Hintbox, aber mit Option für SelectEntityDialog

                let eformHintbox = new HintBox();

                eformHintbox.setLabel(property.hintbox_input_label);
                eformHintbox.suggestionLabelAttribute = property.entity_label_attribute;
                eformHintbox.setLabelAttribute("$Displayname", "ref_eform_type.description");
                eformHintbox.minLetterCount = property.hintbox_min_letter_count;
                eformHintbox.resetOnEdit = true;
                eformHintbox.enablePlainTextValue = false;
                eformHintbox.setCallfunction("Webtool_eForms_API__LoadPropertyHintboxResults");
                eformHintbox.addAdditionalRequestParameter("propertyID", property.ID); // damit API die restliche Konfig wieder findet

                eformHintbox.validationEnabled = entity.is_mandatory == true;

                eformHintbox.enableSelectEntityDialog(true);

                if (entity.value_json) {
                    try {
                        eformHintbox.setValue(JSON.parse(<string>entity.value_json), true);
                        row.input = eformHintbox;
                        this._handleHintboxInlineButtons(row);
                    } catch (e) {
                        console.error("ERROR", e.message, entity);
                    }
                }

                input = eformHintbox;
                eformHintbox.placeAt(row.valueNode);

                break;

            case eFormsPropertyTypes.filterselect:

                let select = new SearchSelect();
                select.setCyName("eFormsPropertyTypes");
               

                //select.setLabel(property.hintbox_input_label);
                select.labelAttribute = "description";
                select.valueAttribute = "value_text";
                select.validationEnabled = true;
                select.setSelectionListLEGACY(entity.ref_eform_property.EL_values)

                select._setPlaceholderAttr("General_Search", "General_DropdownBlank_NoSelection");
                if (entity.is_mandatory) {
                    select._setPlaceholderAttr("General_Search", "General_DropdownBlank_Choose");
                }


                if (entity.ref_eform_property.EL_values.length > 0) {
                    row.valueclass = entity.ref_eform_property.EL_values[0].Classname;
                }

                if (entity.value_json) {
                    try {
                        let data = JSON.parse(<string>entity.value_json);

                        select.setValue(data.ID);
                    } catch (e) {
                        console.error("ERROR parsing values for select-property " + entity.ref_eform_property.description, e.message);
                    }

                }

                input = select;

                this.UiModder.domConstruct.place(input.domNode, row.valueNode);
                break

            case eFormsPropertyTypes.filtermultiselect: //hintbox

                let fmselect = new MultiselectBox();

                //mselect.setLabel(property.hintbox_input_label);
                fmselect.labelAttribute = "description";
                fmselect.valueAttribute = "value_text";
                fmselect.setData(null, entity.ref_eform_property.EL_values);
                fmselect.validationEnabled = entity.is_mandatory === true;;

                fmselect._setPlaceholderAttr("General_Search", "General_DropdownBlank_NoSelection");
                if (entity.is_mandatory) {
                    fmselect._setPlaceholderAttr("General_Search", "General_DropdownBlank_Choose");
                }


                if (entity.ref_eform_property.EL_values.length > 0) {
                    row.valueclass = entity.ref_eform_property.EL_values[0].Classname;
                }

                if (entity.value_json) {
                    try {
                        let data = JSON.parse(<string>entity.value_json);
                        fmselect.setValue(data.selectedValues, true);
                    } catch (e) {
                        console.error("ERROR", e.message);
                    }

                }

                input = fmselect;

                this.UiModder.domConstruct.place(input.domNode, row.valueNode);
                break;

            case eFormsPropertyTypes.replicatingGroup:
                // jetzt gehts los, da brauchen wir eine Art selbstverwaltendes Widget, hier bekommen wir nämlich den Prototyp...

                let groupData: eFormsTypes.PropertiesTableRowGroupData = {
                    groupEntries: [],
                    deletedGUIDS: []
                };

                row.valueNode.innerHTML = TranslationHelpers.translate("eFormsProperties__Group_NoEntries");

                // die Zeile ist mal grundsätzliche ein Gruppe, keine normale propRow:
                domClass.add(row.rowNode, "groupRow");
                domClass.remove(row.rowNode, "propRow");

                if (row.helptextRownode) {
                    domClass.add(row.helptextRownode, "groupRow");
                    domClass.remove(row.helptextRownode, "propRow");

                }

                // die Valuenode nutzen wir als Container für weitere Eigenschaftstabellen
                groupData.groupEntriesNode = row.valueNode;
                domConstruct.empty(row.valueNode);
                domClass.remove(row.valueNode, "flex_row_center");

                // labelnode umbauen: enthält Beschriftung, Button und ggf. Hinweis auf Mindest- und Maximalanzahl
                //domClass.remove(row.labelNode);
                domClass.add(row.labelNode, "groupLabel w3-hide"); // wird nicht mehr gebraucht?
                domConstruct.empty(row.labelNode);

                let stickyContainer = domConstruct.create("div", {
                    "className": ""// "sticky" nix mehr sticky. ist sonst scrollen blöd, jetz wo das alles mit Expandern arbeitet
                }, row.propertyContainerNode, "first");

                domConstruct.create("label", {
                    "className": "title propertyLabel",
                    "innerHTML": property.description
                }, stickyContainer);

                if (this.isReadonly != true) {
                    let addButton = domConstruct.create("button",
                        {
                            "className": "buttonBase addBtn",
                            "innerHTML": property.description
                        },
                        stickyContainer);
                    on(addButton, "click", lang.hitch(this, this._onClick_AddGroupEntry, row, row.propertyDescriptor.EL_groupProperties));

                    groupData.addButton = addButton;
                }

                // max und min
                if (row.propertyDescriptor.group_entries_min && row.propertyDescriptor.is_mandatory) {
                    domConstruct.create("div", {
                        "className": "labelMinValue",
                        "innerHTML": this.stringFormat(
                            TranslationHelpers.translate("eFormsProperties__Group_MinEntriesFormat"),
                            row.propertyDescriptor.group_entries_min )
                    }, stickyContainer);
                }

                if (row.propertyDescriptor.group_entries_max) {
                    domConstruct.create("div", {
                        "className": "labelMaxValue",
                        "innerHTML": this.stringFormat(
                            TranslationHelpers.translate("eFormsProperties__Group_MaxEntriesFormat"),
                            row.propertyDescriptor.group_entries_max)
                    }, stickyContainer);
                }

                row.groupContent = groupData;
                row.value = [];

                if (row.propertyDescriptor.EL_groupEntries) {
                    // guids sammeln von bestehenden Einträgen
                    let data: { guid: string, entries: Array<any> } = null;
                    let assignmentsGrouped = Array<typeof data>();
                    for (let entry of row.propertyDescriptor.EL_groupEntries) {
                        if (!data || data.guid != entry.group_guid) {
                            data = { guid: entry.group_guid, entries: [] };
                            assignmentsGrouped.push(data);
                        }
                        data.entries.push(entry);
                    }

                    for (let data of assignmentsGrouped) {
                        this.addGroupEntryToRow(row, data.entries, data.guid);
                    }
                }
                break;

            default:
                return;
                break;
        }

        if (input) {
            row.input = input;

            // change-Events anhängen und raus
            if (this.isReadonly !== true) {
                on(row.input, "change", lang.hitch(this, this._onInputChanged, row));
            }
        }
    }

    private addGroupEntryToRow(row: eFormsTypes.PropertiesTableRow, assignmentData: Array<eFormsTypes.PropertyAssignment>, guid?: string) {
        //for (let propAssignment of property.EL_groupProperties) {

        //}
        // noch keine Einträge drin - mal die Node leermachen
        if (row.groupContent.groupEntries.length == 0) {
            domConstruct.empty(row.groupContent.groupEntriesNode);
        }
        if (!this._expanderReg) this._expanderReg = {};

        //console.debug("addGroupEntryToRow", row.propertyDescriptor.EL_groupProperties, row.group.groupEntries.length);

        let property = row.propertyDescriptor.ref_eform_property;

        let table = new eFormsProperties();
        table.isReadonly = this.isReadonly === true;
        table.placeAt(row.groupContent.groupEntriesNode);
        let order = 1;
        for (let entry of row.groupContent.groupEntries) {
            if (!entry.deleted) {
                order++;
            }
        }

        let bNewGroup = false;
        if (!guid) {
            guid = "TMP-" + (Math.random() * 1000 * 1000 * 1000).toFixed(0);
            bNewGroup = true;
        }

        let entry: eFormsTypes.PropertiesTableGroupEntry = {
            groupOrder: order,
            table: table,
            values: [],
            parentRow: row,
            groupGUID: guid,
            title: property.description,
        };
        row.groupContent.groupEntries.push(entry);

        table.setData(assignmentData);

        let bPreviousExpanded = false;

        if (!bNewGroup) {
            if (this._expanderReg[guid]) {
                let existingReg = this._expanderReg[guid];
                if (existingReg && existingReg.expanded) {
                    bPreviousExpanded = true;
                }
            }
        }

        table.setGroupMode(entry, bNewGroup || bPreviousExpanded);

        if (!bNewGroup) {
            on(entry.expander, "expand", lang.hitch(this, this._onExpandGroup, true, guid, entry));
            on(entry.expander, "collapse", lang.hitch(this, this._onExpandGroup, false, guid, entry));

        }

        this._expanderReg[guid] = {
            expanded: false,
            expander: entry.expander,
            groupGUID: guid
        };

        //table.StandbyStart();


        on(table, "change", lang.hitch(this, this._onChangeGroupValue, entry));

        this.checkMandatory(row);

        table.buildOutput();

    //    // den delete-Button noch bestücken:
    //    if (entry.clearButton) {
    //        on(entry.clearButton, "click", lang.hitch(this, this._onClick_RemoveGroupEntry, entry));
    //    }
    }

    private _onExpandGroup(bExpanded: boolean, groupGUID: string, entry: eFormsTypes.PropertiesTableGroupEntry) {

        this._expanderReg[groupGUID] = {
            groupGUID: groupGUID,
            expanded: bExpanded,
            expander: entry.expander
        };
    }

    private _onClick_RemoveGroupEntry(deletedEntry: eFormsTypes.PropertiesTableGroupEntry) {
        deletedEntry.deleted = true;
        domClass.add(deletedEntry.table.domNode, "w3-hide");
        let originalDeletedOrder = deletedEntry.groupOrder;
        deletedEntry.groupOrder = 9999;

        //;

        // die Einträge nicht einfach komplett löschen - ggf. muss die Löschung ja auch ans Backend gespeichert werden
        // daher in der Reihenfolge hinaufstellen und deleted-Flag setzen

        let counter = 1;
        let newEntries = [];
        let deletedGuids = [];
        for (let rowEntry of deletedEntry.parentRow.groupContent.groupEntries) {
            if (!rowEntry.deleted) {
                rowEntry.groupOrder = counter;

                if (rowEntry.groupOrder >= originalDeletedOrder) {
                    let groupTitleData: eFormsTypes.GroupPropertyTitles = {
                        groupPropertyID: rowEntry.parentRow.propertyDescriptor.ref_eform_property.ID,
                        order: counter
                    };
                    //console.debug("prepare PropertyTitleFormatting", rowEntry);
                    let childTable: eFormsProperties = rowEntry.table;
                    this.UiModder.domClass.add(childTable.domNode, "obsoleteLabels");
                    this._requestPropertyTitleFormatting(lang.hitch(childTable, childTable.setGroupCountTitles), groupTitleData);
                }

                counter++;
            } else {
                if (deletedGuids.indexOf(rowEntry.groupGUID) == -1) {
                    deletedGuids.push(rowEntry.groupGUID);
                }
            }

            newEntries.push(rowEntry);
        }

        deletedEntry.parentRow.groupContent.groupEntries = newEntries;
        deletedEntry.parentRow.groupContent.deletedGUIDS = deletedGuids;


        this._onChangeGroupValue(deletedEntry);
    }

    private _onChangeGroupValue(targetEntry: eFormsTypes.PropertiesTableGroupEntry, valuesArray?: Array<eFormsTypes.PropertiesTableRowOutput>) {
        //

        // es hat sich in einer Gruppe (targetEntry) was geändert.
    // also die Werte jetzt neu zusammenstellen

        if (typeof (valuesArray) != "undefined") {
            targetEntry.values = valuesArray;
        }
        // gelöschte Einträge werden weiterhin benötigt, weil die ggf. gespeichert gehörtn
        let existingValues: Array<eFormsTypes.PropertiesTableRowOutput> = targetEntry.parentRow.value;
        let newValues: Array<eFormsTypes.PropertiesTableRowOutput> = [];
        let deletedGuids = [];
        let groupEntries = targetEntry.parentRow.groupContent.groupEntries;
        for (let group of groupEntries) {

            // is eh schon im onRemove oben
            //if (group.deleted == true && group.groupGUID) {
            //    if (deletedGuids.indexOf(group.groupGUID, 0) == -1) {
            //        deletedGuids.push(group.groupGUID);
            //    }
            //}
            if (!group.deleted) {
                for (let value of group.values) {

                    value.groupNo = group.groupOrder;
                    newValues.push(value);
                }
            }
        }

        targetEntry.parentRow.value = newValues;
        //targetEntry.parentRow.groupContent.deletedGUIDS = deletedGuids;


        this.checkMandatory(targetEntry.parentRow);
        this.buildOutput();
    }

    private groupEntryCountNode: any = null;

    private _expanderReg: Record<string, propertyExpander>;

    private setGroupMode(parentGroupEntry: eFormsTypes.PropertiesTableGroupEntry, bNewEntry?: boolean): void {
        //this.groupNumber = parentGroupEntry.groupNumber;
        //this.groupGUID = parentGroupEntry.groupGUID;
        this.groupEntryData = parentGroupEntry;

        // wenn ich zu einer Gruppe gehöre: Extraspalte mit dem Zähler
        if (this.groupEntryData && this.rows.length > 0) {


            let expander = new ExpandableSection();



            expander.setupAsReplacement(this.domNode as HTMLElementWithExpander, this.groupEntryData.groupOrder.toString() + ". " + parentGroupEntry.title, "small", true, true, bNewEntry);

            //expander.setMarking(this._checkMandatoryData() ? ExpandableSectionMarkings.default : ExpandableSectionMarkings.warning);
            expander.setFlushContent(true);
            parentGroupEntry.expander = expander;

            this.UiModder.domClass.add(expander.domNode, "w3-margin-bottom brightTransparentBG");

            let span = this.rows[0].rowNode.parentElement.childElementCount;

            //let td: HTMLTableCellElement = <HTMLTableCellElement>this.UiModder.domConstruct.create("td",
            //    {

            //        "className": "groupEntryCounter",
            //        "rowSpan": span.toString(),
            //        style: {

            //        }
            //    }, this.rows[0].rowNode, "first");

            //let container = this.UiModder.domConstruct.create("div", {

            //}, td);

            this.groupEntryCountNode = this.UiModder.domConstruct.create("div", {
                "innerHTML": this.groupEntryData.groupOrder.toString()
            }/*, container*/);


            //let button = domConstruct.create("button", {
            //    "className": "mds-button-base round mds-hover-bright w3-red",
            //    "innerHTML": "<i class='fas fa-trash-alt'></i>"
            //}/*, container*/);

            //if (this.groupEntryData.groupOrder % 2 == 0) {
            //    this.UiModder.domClass.add(this.tableContainer, "ping");
            //} else {
            //    this.UiModder.domClass.add(this.tableContainer, "pong");
            //}


            //parentGroupEntry.clearButton = button;

            //expander.addRightHeadingContent(this.groupEntryCountNode);
            if (!this.isReadonly) {
                expander.addButtonToExpander("delete",
                    lang.hitch(this, this._onClick_RemoveGroupEntry, parentGroupEntry),
                    "fas fa-trash-alt warningTXT",
                    null,
                    "w3-red",
                    "left");
            };


            for (let row of this.rows) {
                row.parentGroupEntry = parentGroupEntry;
            }

            // die Beschriftungen requesten - weil JS kann kein StrFormat...
            if (bNewEntry === true) {// neu erzeugt!
                this._requestPropertyTitleFormatting(lang.hitch(this, this.setGroupCountTitles),
                    {
                        groupPropertyID: parentGroupEntry.parentRow.propertyDescriptor.ref_eform_property.ID,
                        order: parentGroupEntry.groupOrder,
                    });
            }
        }
    }

    private _requestPropertyTitleFormatting(callback: Function, data: eFormsTypes.GroupPropertyTitles, counter?: number) {
        let url: string = window.appRoot + "Eforms/FormatGroupEntryTitles";

        if (!counter) {
            counter = 1;
        }
        this.RequestManager.callfunction(
            "Webtool_eForms_API__FormatGroupEntryTitle",
            data,
            lang.hitch(this, this._onRequestPropertyTitleFormattingResponse, callback),
            lang.hitch(this, this._onRequestPropertyTitleFormattingError, data, callback, counter)
        );
    }

    private _onRequestPropertyTitleFormattingResponse(callback: Function, data: eFormsTypes.GroupPropertyTitles) {
        if (typeof (callback) == "function") {
            callback(data);
        }
    }

    private _onRequestPropertyTitleFormattingError(data: eFormsTypes.GroupPropertyTitles, callback, counter: number, error: more.requestErrorMessage) {
        console.warn("Requested formatted property title, but failed", data, error.Message);

        if (counter < 3) {
            setTimeout(lang.hitch(this, this._requestPropertyTitleFormatting, callback, data, counter + 1), 7000);
        }
    }

    private _onClick_AddGroupEntry(row: eFormsTypes.PropertiesTableRow, properties: Array<eFormsTypes.PropertyAssignment>) {
        if (this.isReadonly) {
            return;
        }
        //;
        this.addGroupEntryToRow(row, properties);
    }

    private _onInputChanged(row: eFormsTypes.PropertiesTableRow): void {
        if (this.isReadonly == true) {
            return;
        }

        let property = row.propertyDescriptor.ref_eform_property;

        switch (property.property_type) {
            case eFormsPropertyTypes.date: //datetime
                let dInput = row.input as MdsLax<InstanceType<typeof DateInput>>;
                let dateResult = dInput.getValue();

                row.value = DateHelpers.dateToLocalISOString(dateResult);
                break;
            case eFormsPropertyTypes.datetime: //datetime
                let dtInput = row.input as MdsLax<InstanceType<typeof DateTimeInput>>;
                let dateTimeResult = dtInput.getValue();

                row.value = DateHelpers.dateToLocalISOString(dateTimeResult?.date);
                break;
            case eFormsPropertyTypes.number:
            case eFormsPropertyTypes.text:
            case eFormsPropertyTypes.textMultiline:
            case eFormsPropertyTypes.multiselect:
            case eFormsPropertyTypes.select:
                row.value = row.input.get("value");
                break;
            case eFormsPropertyTypes.file: // file single
            case eFormsPropertyTypes.multifile: // file multi
                this.readFileInput(row);
                break;
            case eFormsPropertyTypes.filtermultiselect:
                let newValues = {
                    "selectedValues": row.input.getValue(),
                    "Classname": row.valueclass,
                };

                row.value = newValues;
                break;

            case eFormsPropertyTypes.filterselect:
                let newValue = {
                    "ID": row.input.getValue(),
                    "Classname": row.valueclass,
                };

                row.value = JSON.stringify(newValue);
                break;
            case eFormsPropertyTypes.eform:
            case eFormsPropertyTypes.hintbox:
                let hintbox = row.input as MdsLax<InstanceType<typeof HintBox>>;
                let value = hintbox.getValue();

                if (typeof (value) == "string") {
                    row.value = value;
                } else {
                    //row.value = lang.clone(value);
                    row.value = JSON.stringify(value);
                }

                this._handleHintboxInlineButtons(row);
                break;
            default:
                if (row.input) {
                    if (row.input.getValue) {
                        row.value = row.input.getValue();
                    }
                    else if (row.value) {
                        row.value = row.input.value;
                    }
                }
        }

        //console.debug("input change", row.value);

        if (row.notApplicableCB) {
            let cb: MdsLax<InstanceType<typeof CheckBox>> = row.notApplicableCB;
            row.notApplicable = cb.getValue();
        }
        if (row.propertyDescriptor.is_allow_select_not_applicable != true) row.notApplicable = false;

        this.disableNode(row.valueNode, row.notApplicable);

        this.checkMandatory(row);
        this.buildOutput();
    }

    private _handleHintboxInlineButtons(row: eFormsTypes.PropertiesTableRow) {

        if (!row || !row.input) return;
        let property = row.propertyDescriptor.ref_eform_property;
        if (property.property_type == eFormsPropertyTypes.eform) {
            let hintbox = row.input as MdsLax<InstanceType<typeof HintBox>>;
            let value = hintbox.getValue();

            if (!value || typeof (value) != "object") {

            } else {
                let target: eFormsTypes.eFormEntity = value;

                hintbox.addInlineButton(lang.hitch(this, this._onClick_OpenEFormFromProperty, value, row), "gotoEntity", "fas fa-external-link-square-alt");
            }
        }

    }

    private _onClick_OpenEFormFromProperty(target: eFormsTypes.eFormEntity, row: eFormsTypes.PropertiesTableRow) {
        //topic.publish("eForms/OpenEntity", target.ID);
        this.emit("requestEForm", target.ID);
    }

    private readFileInput(row: eFormsTypes.PropertiesTableRow): void {
        let value: FileList = row.input.files;

        // alle Files aus dem Input per Filereader auslesen
        for (let i = 0; i < value.length; i++) {
            let reader: FileReader = new FileReader();
            let file: File = value[i];

            reader.onload = lang.hitch(this, function (value: FileReader, name: string, row: eFormsTypes.PropertiesTableRow) {

                if (value.error != null) {
                    return;
                }

                let newValue = {
                    rawData: value.result,
                    filename: name
                };

                // neues File-Objekt als Descriptor in die Row:
                let descriptor = this.addAttachmentDescriptor(row, newValue);
                this.addDownloadButton(row, descriptor);
                this.setUploadButtonVisibility(row);
                this.checkMandatory(row);
                this.buildOutput();

            }, reader, file.name, row);
            //reader.onerror = lang.hitch(this, "_onFileReader_Error");

            reader.readAsDataURL(file);
        }

    }

    private readAttachments(row: eFormsTypes.PropertiesTableRow): void {

        let filesValue = <eFormsTypes.FilePropertyValue>row.propertyDescriptor.value_json;

        row.value = []; // value wird im addAttachmentDescriptor auf die download-Blobs geändert
        // wenn es aber keine Downloads gibt, steht in value der Wert aus der API, dann weicht das voneinander ab -> blöd
        // also value einmal auf neues Array umschreiben, dann stimmts sicher

        if (filesValue != null) {
            let existingFiles = filesValue.files;
            if (existingFiles) {
                for (let d = 0; d < existingFiles.length; d++) {
                    this.addAttachmentDescriptor(row, existingFiles[d]);
                }
            }
        }

        this.drawDownloadButtons(row);
    }
    private addAttachmentDescriptor(targetrow: eFormsTypes.PropertiesTableRow, fileData): eFormsTypes.PropertiesTable_attachmentDescriptor {
        let descriptor = {
            data: fileData,
            isVirtual: typeof (fileData.ID) == "undefined",
            isRemove: false,
            buttonLabel: fileData.filename
        };

        targetrow.downloads.push(descriptor);

        targetrow.value = targetrow.downloads;

        return descriptor;
    }

    private drawDownloadButtons(row: eFormsTypes.PropertiesTableRow): void {
        let descriptorList: Array<eFormsTypes.PropertiesTable_attachmentDescriptor> = row.downloads;

        this.UiModder.domConstruct.empty(row.downloadsNode);

        for (let i = 0; i < descriptorList.length; i++) {

            let download: eFormsTypes.PropertiesTable_attachmentDescriptor = descriptorList[i];

            // Prozedur überspringen, wenn das Attachment noch nicht in DB steht und schon wieder entfernt wurde
            if (download.isVirtual === true && download.isRemove === true) {
                continue;
            }

            this.addDownloadButton(row, download);
        }

        this.setUploadButtonVisibility(row);
    }

    private addDownloadButton(row: eFormsTypes.PropertiesTableRow, descriptor: eFormsTypes.PropertiesTable_attachmentDescriptor):void {

        let download: eFormsTypes.PropertiesTable_attachmentDescriptor = descriptor;
        let container: HTMLElement = this.UiModder.domConstruct.create("div",
            {
                "className": "flex_row_center w3-padding-y w3-margin-right"
            },
            row.downloadsNode);

        let dlButton: HTMLElement = this.UiModder.domConstruct.create("div");
        this.UiModder.domClass.add(dlButton, "w3-padding-small");
        this.UiModder.domAttr.set(dlButton, "innerHTML", download.buttonLabel);
        this.UiModder.domConstruct.place(dlButton, container);

        if (download.isVirtual != true) {
            this.UiModder.domAttr.set(dlButton, "textDecoration", "none");

            let icon:HTMLElement = this.UiModder.domConstruct.create("i");
            this.UiModder.domClass.add(icon, "fa fa-download w3-margin-left");
            this.UiModder.domConstruct.place(icon, dlButton);

            if (download.isRemove === true) {
                this.UiModder.domClass.add(dlButton, "w3-gray w3-disabled"); //w3-2018-nebulas-blue");
                this.UiModder.domStyle.set(dlButton, "textDecoration", "line-through");
            }

            else {// (download.isRemove != true) {
                this.UiModder.domClass.add(dlButton, "mds-hover-bright w3-2018-quiet-gray"); //w3-2018-nebulas-blue");
                on(dlButton, "click", lang.hitch(this, this._onClick_Download, download));
            }

            // nicht virtuell, nicht Schreibschutz, noch nicht "entfernt" -> darf entfernt werden
            if (this.isReadonly != true && download.isRemove != true) {

                let removeButton: HTMLElement = this.UiModder.domConstruct.create("div");
                this.UiModder.domClass.add(removeButton, "w3-padding-small w3-pale-red mds-hover-bright");
                this.UiModder.domConstruct.place(removeButton, container);

                let icon: HTMLElement = this.UiModder.domConstruct.create("i");
                this.UiModder.domClass.add(icon, "fa fa-times-circle w3-text-red");
                this.UiModder.domConstruct.place(icon, removeButton);

                on(removeButton, "click", lang.hitch(this, this._onClick_RemoveDownload, row, download));

            }

        } else {
            this.UiModder.domClass.add(dlButton, "w3-hover-red w3-light-gray mds-hover-bright hover-strike");

            let icon = this.UiModder.domConstruct.create("i");
            this.UiModder.domClass.add(icon, "fa fa-times-circle w3-margin-left");
            this.UiModder.domConstruct.place(icon, dlButton);

            on(dlButton, "click", lang.hitch(this, this._onClick_RemoveDownload, row, download));
        }

    }

    private setUploadButtonVisibility(row: eFormsTypes.PropertiesTableRow): void {

        let activeButtons = 0;

        if (this.isReadonly != true) {
            for (let i = 0; i < row.downloads.length; i++) {
                // jeden deskriptor prüfen ob der als aktiv gilt
                let download: eFormsTypes.PropertiesTable_attachmentDescriptor = row.downloads[i];

                if (download.isRemove != true) {
                    activeButtons++;
                }
            }
        }

        let property = row.propertyDescriptor.ref_eform_property;
        if (this.isReadonly === true || (property.property_type == 4 && activeButtons > 0)) {
            this.UiModder.domAttr.set(row.input, "disabled", "true");
            this.UiModder.domClass.add(row.input, "w3-hide");

        } else {
            this.UiModder.domAttr.remove(row.input, "disabled");
            this.UiModder.domClass.remove(row.input, "w3-hide");
        }

        row.input.value = null;
    }

    private removeDownloadButton(row: eFormsTypes.PropertiesTableRow, downloadDescriptor: eFormsTypes.PropertiesTable_attachmentDescriptor) {
        if (this.isReadonly === true) {
            return;
        }

        if (downloadDescriptor.isVirtual === true) {
            // noch nicht in DB: wir entfernen den Inhalt komplett
            downloadDescriptor.data = null;
        }

        // remove-Flag setzen
        downloadDescriptor.isRemove = true;

        // button wird hier zerstört und nochmal neu gezeichnet:
        this.drawDownloadButtons(row);
        this.checkMandatory(row);
        this.buildOutput();

    }

    private _onClick_Download(downloadDescriptor: eFormsTypes.PropertiesTable_attachmentDescriptor) {
        if (downloadDescriptor.data != null) {
            let url = window.appRoot + "Eforms/DownloadPropertyFile?ID=" + downloadDescriptor.data.ID;
            window.open(url);
        }
    }

    private _onClick_RemoveDownload(row: eFormsTypes.PropertiesTableRow, downloadDescriptor: eFormsTypes.PropertiesTable_attachmentDescriptor, evt) {
        this.removeDownloadButton(row, downloadDescriptor);
    }

    private _checkMandatoryData(): boolean {
        for (let i = 0; i < this.rows.length; i++) {
            let row: eFormsTypes.PropertiesTableRow = this.rows[i];

            if (row.valid != true) {
                //console.debug("mandatory property not valid", row);
                return false;
            }
        }
        return true;
    }

    setReadOnly(bFlag: boolean = true) {
        this.isReadonly = bFlag == true;

        for (let row of this.rows) {
            if (row.input?.setReadonly) {


                try {
                    (row.input as MdsLax<InstanceType<typeof _StatefulBase>>).setReadonly(bFlag == true);
                } catch (ex) {

                }
            }
            else if (row.input instanceof HTMLInputElement) {
                this.disableNode(row.input, bFlag);
            }
            else if (row.input instanceof HTMLTextAreaElement) {
                this.disableNode(row.input, bFlag);
            }

            if (row.groupContent) {
                this.disableNode(row.groupContent.addButton, bFlag);
                for (let entry of row.groupContent.groupEntries) {
                    try {
                        (entry.table as eFormsProperties).setReadOnly(bFlag);
                    } catch (ex) {

                    }
                }

            }
        }
    }

    private _buildOutputTimeout;
    private buildOutput(bOnlyCheckDirty?: boolean, bSuppressEmit?: boolean) {
        if (this._buildOutputTimeout) clearTimeout(this._buildOutputTimeout);

        this._buildOutputTimeout = setTimeout(lang.hitch(this, this._buildOutput, bOnlyCheckDirty, bSuppressEmit), 150);
    }

    private _buildOutput(bOnlyCheckDirty?: boolean, bSuppressEmit?: boolean) {
        this._buildOutputTimeout = null;

        let currentOutput: string = this._jsonDataString;
        //;
        let newList: Array<eFormsTypes.PropertiesTableRowOutput> = [];
        for (let i = 0; i < this.rows.length; i++) {
            let row: eFormsTypes.PropertiesTableRow = this.rows[i];
            let property = row.propertyDescriptor.ref_eform_property;
            let miniDescriptor: eFormsTypes.PropertyAssignmentMini = {
                ID: row.propertyDescriptor.ID,
                Classname: row.propertyDescriptor.Classname,
                is_mandatory: row.propertyDescriptor.is_mandatory,
                group_guid: row.propertyDescriptor.group_guid,
                ref_eform_property: {
                    ID: property.ID,
                    property_type: property.property_type
                },
                ref_ht_eform_property_group_source: row.propertyDescriptor.ref_ht_eform_property_group_source
            };
            newList.push({
                propertyTitle: property.description,
                descriptor: miniDescriptor,
                notApplicable: row.notApplicable,
                value: row.value,
                groupNo: this.groupEntryData ? this.groupEntryData.groupOrder : null,
                groupGUID: this.groupEntryData ? this.groupEntryData.groupGUID : null, // ICH BIN ein Gruppeneintrag
                deletedGUIDs: row.groupContent ? row.groupContent.deletedGUIDS : null, // ich HABE ggf. Gruppeneinträge die gelöscht wurden
                ID: row.propertyDescriptor.ID
            });

        }

        //console.debug("new output built", newList);

        let newOutput: string = JSON.stringify(newList);

        if (bOnlyCheckDirty !== true) {
            this._jsonDataString = newOutput;
            this._jsonDataOut = newList;
        }

        if (newOutput != currentOutput && bSuppressEmit !== true) {
            this.emit("change", newList);
        }

        return newList;
    }

    private _createDateInput(row: eFormsTypes.PropertiesTableRow, cellValue: string | Date): MdsLax<InstanceType<typeof DateInput>> {
        let dateInput: MdsLax<InstanceType<typeof DateInput>> = new DateInput();

        this.UiModder.domStyle.set(dateInput.domNode, "width", "100%");

        row.input = dateInput;

        if (row.propertyDescriptor.is_mandatory === true && this.isReadonly != true) {
            dateInput.setMandatory(true);
            dateInput.setValidationEnabled(true);
        }


        if (cellValue != null && cellValue != "") {

            if (typeof cellValue == "string") {
                cellValue = new Date(cellValue);
            }

            if (!isNaN(cellValue.getFullYear())) {
                dateInput.setValue(cellValue, true);
            } else {
                console.error("wrong date format")
            }
        }

        dateInput.placeAt(row.valueNode);
        //on(dateInput, "change", lang.hitch(this, this._onInputChanged, row));

        if (this.isReadonly === true) {
            row.input.setReadonly(this.isReadonly);
        }

        return dateInput;
    }
    private _createDatetimeInput(row: eFormsTypes.PropertiesTableRow, cellValue: string | Date): MdsLax<InstanceType<typeof DateTimeInput>> {
        let datetimeInput: MdsLax<InstanceType<typeof DateTimeInput>> = new DateTimeInput();

        this.UiModder.domStyle.set(datetimeInput.domNode, "width", "100%");

        row.input = datetimeInput;

        if (row.propertyDescriptor.is_mandatory === true && this.isReadonly != true) {
            datetimeInput.setMandatory(true);
            datetimeInput.setValidationEnabled(true);
        }


        if (cellValue != null && cellValue != "") {

            if (typeof cellValue == "string") {
                cellValue = new Date(cellValue);
            }

            if (!isNaN(cellValue.getFullYear())) {
                datetimeInput.setValue(cellValue, true);
            } else {
                console.error("wrong date format")
            }
        }

        datetimeInput.placeAt(row.valueNode);
        //on(datetimeInput, "change", lang.hitch(this, this._onInputChanged, row));

        if (this.isReadonly === true) {
            row.input.setReadonly(this.isReadonly);
        }

        return datetimeInput;
    }

    private getRowByKey(key: string): eFormsTypes.PropertiesTableRow {
        for (let i = 0; i < this.rows.length; i++) {
            let entity = this.rows[i].propertyDescriptor;

            if (entity.ID == key) {
                return this.rows[i];
            }
        }

        return null;
    }

    setData(data: Array<eFormsTypes.PropertyAssignment>, groupData?: eFormsTypes.PropertiesTableGroupEntry): void {
        this._jsonDataIn = data;
        //;
        this.drawTable();
    }

    _setDataAttr(data: Array<eFormsTypes.PropertyAssignment>) {
        this.setData(data);
    }
    private groupRowspan: HTMLElement = null;

    drawTable(): void {
        //console.debug("eFormsproperties drawtable", this._jsonDataIn);

        let previousExpandedGuids: Array<string> = [];
        if (this._expanderReg) {
            for (let key in this._expanderReg) {
                let reg = this._expanderReg[key];
                if (reg.expanded) {
                    previousExpandedGuids.push(key);
                }
            }
        }
        this.UiModder.domConstruct.empty(this.tbodyContainer);
        this.rows = [];

        this.hideNode(this.navigationContainer, true);
        this.UiModder.domConstruct.empty(this.navigationContainer);

        //console.log("ROWS: ", this._jsonDataIn);

        if (this._jsonDataIn != null) {


            for (let i = 0; i < this._jsonDataIn.length; i++) {
                let assignment = this._jsonDataIn[i];

                this.drawRow(assignment);

            }
        }



        this.checkMandatory();
        this.buildOutput(false, true);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "json";
        this.PitHelper._structureFormat = "json";
        this.rows = [];
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

    }
}

export default mdsWidget(eFormsProperties);
